import { Radar } from "./radar.class";
import { MediaDefinition, SceneDefinition } from "./VV.class";

interface HotspotClickEvent {
  key: string;
  data: any;
}

class SituationMap {
  div: HTMLDivElement;
  scene: MediaDefinition;
  hotspots: Radar[];
  public onclickhotspot: (evt: HotspotClickEvent) => void;
  constructor() {
    const div = document.createElement("div");
    div.style.position = "relative";
    div.style.width = "100%";
    div.style.height = "100%";
    this.div = div;
  }
  getDomElement() {
    return this.div;
  }
  setScene(scene: SceneDefinition) {
    const img = document.createElement("img");
    img.style.position = "absolute";
    img.style.width = "100%";
    img.style.height = "100%";
    img.style.top = "0";
    img.style.left = "0";
    this.div.innerHTML = "";
    const pm: MediaDefinition = scene.medias.find(
      (m: MediaDefinition) => m.type === "pm"
    );
    this.scene = pm;
    img.src = pm.url;
    this.div.appendChild(img);
    const { position, rotation, fov, target } = pm.coords;
    const camWidth =
      Math.tan(((fov / 2) * Math.PI) / 180) * (position[2] - target[2]);

    const angle = (-1 * (rotation[2] * Math.PI)) / 180;
    const hotspots = scene.medias
      .filter((m: MediaDefinition) => m.type === "visite")
      .map((h) => {
        const radar = new Radar(h.key);
        const element = radar.getDomElement() as HTMLElement;
        element.style.position = "absolute";

        const translated = {
          x: h.coords.position[0] - position[0],
          y: h.coords.position[1] - position[1],
        };
        const rotated = {
          x: Math.cos(angle) * translated.x - Math.sin(angle) * translated.y,
          y: Math.sin(angle) * translated.x + Math.cos(angle) * translated.y,
        };
        element.style.left = (rotated.x / (camWidth * 2) + 0.5) * 100 + "%";
        element.style.bottom = (rotated.y / (camWidth * 2) + 0.5) * 100 + "%";
        element.style.transform = "translate(-50%,50%)";
        this.div.appendChild(element);
        radar.draw();
        element.onclick = () => {
          this.onclickhotspot &&
            this.onclickhotspot({ key: radar.key, data: radar });
        };
        return radar;
      });
    this.hotspots = hotspots;
  }

  activateHotspot(key: string): void {
    this.hotspots.forEach((h) => {
      if (h.key === key) {
        h.setActive(true);
      } else {
        h.setActive(false);
      }
    });
  }

  updateHotspot(
    key: string,
    { angle, rotation }: { angle: number; rotation: number }
  ): void {
    const hotspot = this.hotspots.find((h) => h.key === key);
    hotspot.setAngle(angle);
    hotspot.setRotation(rotation + this.scene.coords.rotation[2] - 90);
  }

  getHotspots() {
    return this.hotspots;
  }
  getHotspot(key: string) {
    return this.hotspots.find((h) => h.key === key);
  }
}

export { SituationMap };
